import GoldenRockExitFreespins from "goldenrock/states/golden-rock-exit-freespins";
import {BetBarType} from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import smartUiFlags, {SmartUIFlag} from "slotworks/smart-ui/smart-ui-flags";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";
import backgroundTint from "components/show-win-lines/background-tint";
import sgWinRespinCelebrator from "components/sg-win-respin-celebrator";
import sgScatterAnimation from "components/sg-scatter-animation";
import sgSandAnimation from "components/sg-sand-animation";

export default class SGExitFreespins extends GoldenRockExitFreespins {

    public onEnter(): void {
        backgroundTint.hide();
        Components.betBar.setType(BetBarType.DEFAULT);

        Components.matrix.getReels().forEach((reel) => reel.setVisible(true));
        sgSandAnimation.stopSandAnimation();
        sgScatterAnimation.resetAllAnimations();
        super.onEnter();
    }

    protected setupPrompt(): Contract<void> {
        smartUiFlags.set(SmartUIFlag.FREE_SPINS, false);

        this.prompt = new PromptContent(["freespinssummary"], Infinity);
        this.prompt.setClickToSkip(true);

        return super.setupPrompt();
    }

    protected hideFreespinsComponents(): Contract<void> {
        return new Parallel([
            () => super.hideFreespinsComponents(),
            () => Layers.MatrixForeground.defaultScene()
        ]);
    }
}
